<div fxLayout="column"
     fxLayoutAlign="center center"
     class="w-100"
     ngClass.desktop="pr-56 pl-56 pb-48 pt-48"
     ngClass.mobile="pr-16 pl-16 pb-12 pt-12">
    <div class="h3-semi-bold c-primary-gray-900 text-center pre-line"
         ngClass.mobile="mt-36">
        {{ 'i18n_auth_eSignCodeTitle#' + dialogMode | translate }}
    </div>
    <div class="mt-8 t2 c-primary-gray-600 text-center pre-line">
        {{ 'i18n_auth_eSignCodeSubtitle#' + dialogMode | translate }}
    </div>
    @if (hasOrgSignScope) {
        <div fxLayout="row" fxLayoutAlign="center center" class="text-center mt-16 w-100 h-44 bc-primary-green-50 p-12">
            <ui-kit-svg class="i-32" name="ic_cloud_esign_green"></ui-kit-svg>
            <span class="t2-semi-bold ml-8">{{ 'i18n_auth_eSignConsentTitleUl' | translate }}</span>
        </div>
    } @else {
        <div fxLayout="row" fxLayoutAlign="center center" class="text-center mt-16 w-100 h-44 bc-secondary-blue-100 pt-12 pb-12">
            <ui-kit-svg class="i-32" name="ic_cloud_esign_blue"/>
            <span class="t2-semi-bold ml-8">{{ 'i18n_auth_eSignConsentTitleFl' | translate }}</span>
        </div>
    }
    @if (dialogMode !== ESignDialogMode.REISSUE_INFO) {
        <div class="mt-32" fxLayout="column" fxLayoutAlign="start start">
            @if (dialogMode !== ESignDialogMode.REVOCATION) {
                <div class="t2 c-primary-gray-600 ml-8">{{ 'i18n_auth_eSignCodeLabel'| translate }}</div>
            }
            <ui-kit-code-input #codeInput
                               fxFlexAlign="center"
                               class="mt-4"
                               [class.error]="codeError"
                               [isCodeHidden]="true"
                               [isCharsCode]="false"
                               [codeLength]="codeLength"
                               [initialFocusField]="0"
                               [isFocusingOnLastByClickIfFilled]="true"
                               [isPrevFocusableAfterClearing]="false"
                               (codeCompleted)="onCodeComplete($event)"
                               (codeChanged)="onCodeChanged()">
            </ui-kit-code-input>
            @if (codeError === ESignCodeDialogResultCode.CODE_INVALID) {
                <div fxFlexAlign="start" class="ml-8 mt-4">
                    <div class="t2 c-secondary-red-800">{{ 'i18n_auth_errorCodeInvalid' | translate: {count: attemptsLeft} }}</div>
                </div>
            }
        </div>
        @if (dialogMode === ESignDialogMode.ISSUE_AND_SIGN
        || dialogMode === ESignDialogMode.REISSUE_AND_SIGN
        || dialogMode === ESignDialogMode.REISSUE) {
            <div class="mt-40" fxLayout="column" fxLayoutAlign="start start">
                <div class="t2 c-primary-gray-600 ml-8">{{ 'i18n_auth_eSignCodeRepeatLabel'| translate }}</div>
                <ui-kit-code-input #codeInputRepeat
                                   fxFlexAlign="center"
                                   class="mt-4"
                                   [class.error]="codeError"
                                   [isCodeHidden]="true"
                                   [isCharsCode]="false"
                                   [codeLength]="codeLength"
                                   [initialFocusField]="0"
                                   [isFocusingOnLastByClickIfFilled]="true"
                                   [isPrevFocusableAfterClearing]="false"
                                   (codeCompleted)="onCodeRepeatComplete($event)"
                                   (codeChanged)="onCodeChanged()">
                </ui-kit-code-input>
                @if (codeError === ESignCodeDialogResultCode.CODES_NOT_MATCHED) {
                    <div fxFlexAlign="start" class="ml-8 mt-4">
                        <div class="t2 c-secondary-red-800">{{ 'i18n_auth_errorCodeNotMatched' | translate }}</div>
                    </div>
                }
            </div>
        }
        @if (dialogMode === ESignDialogMode.SIGN || dialogMode === ESignDialogMode.REVOCATION) {
            <ui-kit-button type="text"
                           color="primary"
                           class="mt-40"
                           ngClass.mobile="w-100"
                           [label]="'i18n_auth_buttonForgotPassword' | translate"
                           (clickListener)="forgotCode()"/>
        }
    }
    @if (dialogMode !== ESignDialogMode.SIGN) {
        <ui-kit-checkbox appearance="small"
                         class="mt-40"
                         [(ngModel)]="isAcceptanceApplied">
            <div class="pre-line"
                 [innerHTML]="((dialogMode === ESignDialogMode.REISSUE_INFO || dialogMode === ESignDialogMode.REVOCATION ? 'i18n_auth_eSignRevokeAgreement' : 'i18n_auth_eSignIssueAgreement') | translate) | safeHtml"
                 [commonsClickById]="{downloadIssueAgreement, downloadRevocationAgreement}">
            </div>
        </ui-kit-checkbox>
    }
    <ui-kit-button class="mt-40"
                   ngClass.mobile="w-100"
                   [label]="'i18n_auth_buttonCode#' + dialogMode | translate"
                   (clickListener)="submit()"
                   spinnerId="eSignInProgress"
                   [disabled]="!isButtonEnabled()"/>
</div>
